export const isObject = (value: any): boolean => (
  value != null && value.constructor.name === "Object"
);
